var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"height":"282px"}},[_c('v-card-text',{staticClass:"black--text pt-2"},[_c('v-row',{staticStyle:{"align-items":"center"},attrs:{"no-gutters":""}},[_c('v-col',[_c('span',{staticClass:"text-h6 font-weight-regular"},[_vm._v(" "+_vm._s(_vm.selectedStations[0].rastless_product.toUpperCase())+" - "+_vm._s(_vm.$t("baseline.monthlyComparison")))])]),_c('v-spacer'),_c('v-col',{attrs:{"cols":"auto"}},[_c('year-filter',{attrs:{"years":_vm.years},on:{"filteredYears":_vm.changeYears}})],1)],1)],1),_c('div',{ref:"plot",style:({
      top: 0,
      bottom: 0,
      width: '100%',
      height: '70%'
    }),attrs:{"id":"monthly-comparison"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }